(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@babel/runtime/regenerator'), require('@babel/runtime/helpers/asyncToGenerator'), require('normalizr'), require('@babel/runtime/helpers/toConsumableArray'), require('@babel/runtime/helpers/defineProperty'), require('@babel/runtime/helpers/typeof')) : typeof define === 'function' && define.amd ? define(['exports', '@babel/runtime/regenerator', '@babel/runtime/helpers/asyncToGenerator', 'normalizr', '@babel/runtime/helpers/toConsumableArray', '@babel/runtime/helpers/defineProperty', '@babel/runtime/helpers/typeof'], factory) : factory(global['model-graph'] = {}, global._regeneratorRuntime, global._asyncToGenerator, global.normalizr, global._toConsumableArray, global._defineProperty, global._typeof);
})(this, function (exports, _regeneratorRuntime, _asyncToGenerator, normalizr, _toConsumableArray, _defineProperty, _typeof) {
  'use strict';

  _regeneratorRuntime = _regeneratorRuntime && _regeneratorRuntime.hasOwnProperty('default') ? _regeneratorRuntime['default'] : _regeneratorRuntime;
  _asyncToGenerator = _asyncToGenerator && _asyncToGenerator.hasOwnProperty('default') ? _asyncToGenerator['default'] : _asyncToGenerator;
  _toConsumableArray = _toConsumableArray && _toConsumableArray.hasOwnProperty('default') ? _toConsumableArray['default'] : _toConsumableArray;
  _defineProperty = _defineProperty && _defineProperty.hasOwnProperty('default') ? _defineProperty['default'] : _defineProperty;
  _typeof = _typeof && _typeof.hasOwnProperty('default') ? _typeof['default'] : _typeof;

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }
  /*
   * Action struct: {
    * Used by savePromise ->
   *  callId: string,
    * Save & map promise to callId in order to avoid replaying this call ->
   *  savePromise: bool,
    * Object containing entity's id to be returned if already fetched
   * (for instance by a dependant entity) ->
   *  autoGetter: {id: id},
    * Value to insert just after call & updated by async fetch result ->
   *  quickInsert : object,
     *  fetch: (dispatch, getState) => Promise,
    * Optional, if deletion ->
   *  action: 'delete',
    * Name of store which has to recv datas ->
   *  outputStore: string,
    * Callback triggered on call's end ->
   *  endCallback: ({result, dispatch, getState}) => result
   * }
   */


  function modelGraphReduxMiddleware(_ref) {
    var _ref$dispatchAction = _ref.dispatchAction,
        dispatchAction = _ref$dispatchAction === void 0 ? 'UPDATE_MODEL_STORE' : _ref$dispatchAction,
        datascheme = _ref.datascheme;

    datascheme.dispatchAction = function (storeName) {
      return {
        storeName: storeName,
        type: dispatchAction,
        store: datascheme.store(storeName).clone()
      };
    };

    return function (_ref2) {
      var dispatch = _ref2.dispatch,
          getState = _ref2.getState;
      return function (next) {
        return /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(action) {
            var requestBuilder, request, fetchRequest, quickInsertRequest, data;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    quickInsertRequest = function _ref6(action) {
                      var objectId = action.quickInsert.objectId || Date.now();

                      var quickInsert = _objectSpread({}, action.quickInsert, {
                        objectId: objectId
                      });

                      fetchRequest({
                        fetch: function fetch() {
                          return Promise.resolve(quickInsert);
                        },
                        groups: action.groups
                      });
                      return fetchRequest(_objectSpread({}, action, _defineProperty({}, action.quickInsert.objectId ? 'update' : 'replace', objectId)));
                    };

                    fetchRequest = function _ref5(_ref4) {
                      var fetch = _ref4.fetch,
                          action = _ref4.action,
                          groups = _ref4.groups,
                          endCallback = _ref4.endCallback,
                          replace = _ref4.replace;
                      var request = requestBuilder();
                      request.call(fetch, dispatch, getState);

                      if (action === 'delete') {
                        request["delete"]();
                      } else {
                        request.store({
                          groups: groups,
                          replace: replace
                        });
                      }

                      if (endCallback) {
                        request.call(endCallback, dispatch, getState);
                      }

                      return request.call(function (result) {
                        request.updatedStores.forEach(function (storeName) {
                          return dispatch(datascheme.dispatchAction(storeName));
                        });
                        return result;
                      }).result;
                    };

                    if (!(_typeof(action) !== 'object' || !action.fetch || !action.outputStore)) {
                      _context.next = 4;
                      break;
                    }

                    return _context.abrupt("return", next(action));

                  case 4:
                    requestBuilder = datascheme.request.bind(datascheme, action.outputStore);
                    request = requestBuilder();

                    if (request) {
                      _context.next = 8;
                      break;
                    }

                    throw new Error({
                      error: 'ReduxModelStore: unkown store ' + action.outputStore
                    });

                  case 8:
                    if (!(action.autoGetter && action.autoGetter.id)) {
                      _context.next = 14;
                      break;
                    }

                    _context.next = 11;
                    return request.get(action.autoGetter.id).result;

                  case 11:
                    data = _context.sent;

                    if (!data) {
                      _context.next = 14;
                      break;
                    }

                    return _context.abrupt("return", Promise.resolve(data));

                  case 14:
                    if (!action.savePromise) {
                      _context.next = 16;
                      break;
                    }

                    return _context.abrupt("return", request.savedCall({
                      uniqId: action.callId,
                      fn: function fn() {
                        return fetchRequest(action);
                      }
                    }).result);

                  case 16:
                    if (!action.quickInsert) {
                      _context.next = 18;
                      break;
                    }

                    return _context.abrupt("return", quickInsertRequest(action));

                  case 18:
                    return _context.abrupt("return", fetchRequest(action));

                  case 19:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref3.apply(this, arguments);
          };
        }();
      };
    };
  }

  function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread$1(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys$1(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys$1(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function DataStore(model, opts) {
    this.model = model; // Mapping entity ids to entities

    this.entitiesMap = {}; // Entities groups, maps groups names to entities id array

    this.groups = {
      all: []
    };
    this.clone = clone.bind(this);
    this.addToGroups = addToGroups.bind(this);
    this.getGroup = getGroup.bind(this);
    this.updateLinkField = updateLinkField.bind(this);
    this.updateEntity = updateEntity.bind(this);
    this.update = update.bind(this);
    this.replace = replace.bind(this);
    this["delete"] = _delete.bind(this);
    this.deleteFromGrp = deleteFromGrp.bind(this);
    this.clear = clear.bind(this);
    this.get = get.bind(this);
    this.getArray = getArray.bind(this);

    function clone() {
      return Object.assign({}, this, {
        entitiesMap: _objectSpread$1({}, this.entitiesMap),
        groups: _objectSpread$1({}, this.groups)
      });
    }

    function addToGroups(entity, groups) {
      var _this = this;

      groups = groups.filter(function (cur) {
        return entity.__metas.groups.indexOf(cur) === -1;
      });
      groups.forEach(function (name) {
        if (!(name in _this.groups)) {
          _this.groups[name] = [];
        }

        _this.groups[name].push(entity[_this.model.idAttribute]);
      });
      entity.__metas.groups = [].concat(_toConsumableArray(entity.__metas.groups), _toConsumableArray(groups));
    }

    function getGroup(group) {
      return (this.groups[group] || []).map(this.get);
    }

    function updateLinkField(id, field, newId) {
      var entity = this.get(id);

      if (Array.isArray(entity[field])) {
        if (entity[field].includes(newId)) {
          return false;
        }

        entity[field].push(newId);
      } else {
        if (entity[field] === newId) {
          return false;
        }

        entity[field] = newId;
      }

      return true;
    }

    function updateEntity(entity) {
      var id = entity[this.model.idAttribute] + '';
      var current = this.get(id); // Defining prototypes (according to model's one + metadatas)

      var proto = current && Object.getPrototypeOf(current);

      if (!proto) {
        // TODO clone before update for redux
        proto = Object.create(Object.assign({
          __metas: {
            groups: []
          }
        }, this.model.proto));
      } else {
        proto = Object.create(proto);
      } // Updating entity


      entity = Object.assign(proto, current, entity);
      this.entitiesMap[id] = entity;
      return entity;
    }

    function update(entities) {
      var _this2 = this;

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          groups = _ref.groups;

      var single = false;

      if (!Array.isArray(entities)) {
        single = true;
        entities = [entities];
      }

      entities = entities.map(function (cur) {
        cur = _this2.updateEntity(cur);
        var entityGroups = groups;

        if (!cur.__metas.groups.length) {
          entityGroups = entityGroups ? ['all'].concat(_toConsumableArray(entityGroups)) : ['all'];
        } // Updating groups if any


        if (entityGroups && entityGroups.length) {
          _this2.addToGroups(cur, entityGroups);
        }

        return cur;
      });
      return single ? entities[0] : entities;
    }

    function replace(oldId, newEntity) {
      var _this3 = this;

      var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          groups = _ref2.groups;

      var old = this.get(oldId);
      newEntity = this.updateEntity(newEntity);

      if (old) {
        old.__metas.groups.forEach(function (name) {
          _this3.groups[name] = _this3.groups[name].map(function (cur) {
            return cur === oldId ? newEntity[_this3.model.idAttribute] : cur;
          });
        });

        newEntity.__metas.groups = old.__metas.groups;
        this["delete"](oldId);
      }

      return newEntity;
    }

    function _delete(id) {
      var _this4 = this;

      var entity = this.get(id);

      if (!entity) {
        return this;
      }

      entity.__metas.groups.forEach(function (grp) {
        return _this4.deleteFromGrp(id, grp);
      });

      delete this.entitiesMap[id + ''];
    }

    function deleteFromGrp(id, grp) {
      if (!this.groups[grp]) {
        return this;
      }

      this.groups[grp] = this.groups[grp].filter(function (cur) {
        return cur !== id;
      });
      return this;
    }

    function clear() {
      this.entitiesMap = {};
      this.groups = {
        all: []
      };
      return this;
    }

    function get(id) {
      return this.entitiesMap[id + ''];
    }

    function getArray(list) {
      if (!list) {
        return this.groups.all.map(this.get);
      }

      return list.map(this.get);
    }
  }

  function requestBuilder(datascheme) {
    return function (targetStore) {
      var store = datascheme.store(targetStore);
      var model = datascheme.model(targetStore);
      var idAttribute = model.idAttribute; // Implements differents handlers linking user input / methods to stores

      return function ModelRequest(input) {
        var _this = this;

        this.result = Promise.resolve(input);
        this.updatedStores = new Set();

        this.value = function (val) {
          _this.result = Promise.resolve(val);
          return _this;
        };

        this.get = function (id) {
          return _this.value(store.get(id));
        };

        this.then = function () {
          var _this$result;

          return (_this$result = this.result).then.apply(_this$result, arguments);
        }; // Perform call, save their result and metadatas
        // If oneshot is false, fn can't be called twice at the same time,
        // but can be performed again as soon as previous call has ended
        // By default, fn will not ever be called more than 1 time


        this.savedCall = function (_ref) {
          var callId = _ref.callId,
              _ref$oneshot = _ref.oneshot,
              oneshot = _ref$oneshot === void 0 ? true : _ref$oneshot,
              fn = _ref.fn,
              _ref$params = _ref.params,
              params = _ref$params === void 0 ? [] : _ref$params;
          var saved = datascheme.savedCall(callId); // Return saved call only if oneshot is enabled OR call is still running

          if (saved && (oneshot || saved.running)) {
            return _this.value(saved.result);
          }

          _this.call(fn, params);

          datascheme.saveCall(callId, _this.result, true);
          return _this.call(function (result) {
            return datascheme.saveCall(callId, result, false);
          });
        };

        this.call = function (fn) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          _this.result = new Promise(function (resolve, reject) {
            _this.result["catch"](function (error) {
              reject(error);
            }).then(function (val) {
              return resolve(fn.apply(void 0, [val].concat(args)));
            });
          });
          return _this;
        };

        this["delete"] = function (id) {
          return _this.call(function (data) {
            id = id || data.id;

            if (id === undefined) {
              return;
            }

            _this.updatedStores.add(targetStore);

            return store["delete"](id);
          });
        }; // Given some entities and their modelName, look for any linked model
        // in other stores.
        // Update every found entities link attributes accordingly


        this.fillLinkedModelsWith = function (entities, modelName) {
          if (!(modelName in datascheme.autolinks)) {
            return;
          } // Can this model fill another one ?


          var autolinks = datascheme.autolinks[modelName]; // Go through each of them

          autolinks.forEach(function (autolink) {
            var linkedStore = datascheme.store(autolink.linkedModel);
            var linkedModelIdAttr = linkedStore.model.idAttribute; // Get each of these entities that may fill
            // remote entities of current autolink

            entities.forEach(function (entity) {
              var linkedId = _typeof(entity[autolink.via]) === 'object' ? entity[autolink.via][linkedModelIdAttr] : entity[autolink.via];
              var linkedEntity = linkedStore.get(linkedId);

              if (!linkedEntity || !linkedStore.updateLinkField(linkedId, autolink.linkedAttr, entity[idAttribute])) {
                return;
              }

              _this.updatedStores.add(autolink.linkedModel);
            });
          });
        }; // Update every stores with current value


        this.store = function () {
          var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              value = _ref2.value,
              groups = _ref2.groups,
              replace = _ref2.replace;

          return _this.call(function (ret) {
            if (value) {
              ret = value;
            }

            if (!ret) {
              return;
            }

            ret = model.normalize(ret); // Loop over each different models extracted from api return

            var result = null;
            Object.keys(ret.entities).forEach(function (storeName) {
              _this.updatedStores.add(storeName);

              var datas = Object.values(ret.entities[storeName]);

              _this.fillLinkedModelsWith(datas, storeName); // Target store model -> save datas that we'll return


              if (targetStore === storeName) {
                if (typeof replace !== 'undefined') {
                  result = store.replace(replace, datas[0]);
                } else {
                  result = store.update(datas.length < 2 ? datas[0] : datas, {
                    groups: groups
                  });
                }
              } else {
                datascheme.store(storeName).update(datas.length < 2 ? datas[0] : datas);
              }
            });
            return result;
          });
        };
      };
    };
  }

  function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread$2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys$2(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys$2(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function DataScheme(models) {
    var _this = this;

    var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var self = this;
    this.savedCalls = {};
    this.models = {}; // Details model attributes to be filled on linked models instantiation
    // Keys are model names, values are list of models with attribute that
    // may be autofilled from first model instantiation

    this.autolinks = {};

    function Model(name) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.idAttribute = opts.idAttribute || 'id';
      this.normalizr = new normalizr.schema.Entity(name, {}, _objectSpread$2({
        idAttribute: this.idAttribute
      }, opts.normalizrEntityParams || {}));
      this.name = name;
      this.dependencies = {};
      this.proto = {};

      this.link = function (attr, linkedModel) {
        var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var linkedModelName = ''; // Give normalizr entity the information of linked model

        if (Array.isArray(linkedModel)) {
          this.normalizr.define(_defineProperty({}, attr, linkedModel.map(function (cur) {
            return cur.normalizr;
          })));
          linkedModelName = linkedModel[0].name;
        } else {
          this.normalizr.define(_defineProperty({}, attr, linkedModel.normalizr));
          linkedModelName = linkedModel.name;
        }

        this.dependencies[attr] = {
          model: linkedModel
        }; // 'via' autolinks

        if (opts.via) {
          if (!opts.via.attr) {
            throw new Error({
              error: 'model-graph \'via\' option of entity.link() \
            at least needs \'attr\' attribute.'
            });
          }

          if (!(linkedModelName in self.autolinks)) {
            self.autolinks[linkedModelName] = [];
          }

          self.autolinks[linkedModelName].push({
            linkedModel: name,
            linkedAttr: attr,
            // Corresponds to linkedModel attribute (pointing to cur model id) :
            via: opts.via.attr
          });
        }

        return this;
      };

      this.normalize = function (datas) {
        var model = this.normalizr;

        if (Array.isArray(datas)) {
          model = [model];
        }

        var ret = normalizr.normalize(datas, model);
        return ret;
      };
    } // Define a new model with its associated store


    this.define = function (name, opts) {
      var model = new Model(name, {
        idAttribute: opts.idAttribute || args.idAttribute
      });
      var proto = opts.proto || {};
      Object.defineProperty(proto, '_populate', {
        value: _populate
      });
      Object.defineProperty(proto, '_model', {
        value: name
      });
      Object.defineProperty(proto, '_id', {
        get: function get() {
          return this[model.idAttribute];
        }
      });
      model.proto = proto;
      _this.models[name] = {
        model: model,
        store: new DataStore(model, opts),
        Request: null,
        opts: opts
      };
      _this.models[name].Request = requestBuilder(_this)(name);
      return _this;
    }; // Call schemeFn with every models as parameter


    this.linking = function (schemeFn) {
      var models = Object.keys(_this.models).reduce(function (stores, curName) {
        stores[curName] = _this.model(curName);
        return stores;
      }, {});
      schemeFn(models);
    }; // Getters


    this.model = function (name) {
      if (!(name in _this.models)) {
        throw new Error({
          error: "model-graph: try to get unknown '".concat(name, "' model")
        });
      }

      return _this.models[name] && _this.models[name].model;
    };

    this.store = function (name) {
      return _this.models[name] && _this.models[name].store;
    };

    this.request = function (name) {
      return _this.models[name] && new _this.models[name].Request();
    };

    this.allStores = function () {
      return Object.keys(_this.models).reduce(function (stores, curName) {
        stores[curName] = _this.store(curName);
        return stores;
      }, {});
    }; // Returns saved call corresponding to given id


    this.saveCall = function (callId, result, running) {
      _this.savedCalls[callId] = {
        result: result,
        running: running,
        time: new Date()
      };
      return result;
    };

    this.savedCall = function (callId) {
      return _this.savedCalls[callId];
    };

    this.isRunningCall = function (callId) {
      return _this.savedCalls[callId] && _this.savedCalls[callId].running;
    }; // Models helpers : need 'this' to point a valid entity


    function _populate(stores) {
      var clone = Object.assign(Object.create(Object.getPrototypeOf(this)), this);
      var modelDependencies = self.models[this._model].model.dependencies;

      for (var attr in modelDependencies) {
        if (attr in clone && clone[attr]) {
          clone[attr] = stores[modelDependencies[attr].model].get(clone[attr]);
        }
      }

      return clone;
    } // Init


    for (var name in models) {
      this.define(name, _typeof(models[name]) === 'object' ? models[name] : undefined);
    }
  }

  function reduxMiddleware(params) {
    if (!params.datascheme) {
      throw new Error({
        error: 'Missing model-graph datascheme'
      });
    }

    return modelGraphReduxMiddleware(params);
  }

  exports.reduxMiddleware = reduxMiddleware;
  exports.DataScheme = DataScheme;
  exports.DataStore = DataStore;
  exports.requestBuilder = requestBuilder;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});